<script setup>
import { ref, inject } from 'vue'
const rootAppProvide = inject('rootAppProvide')
</script>

<template>
  <footer class="commonFooter">
    <div>
      <p><small>Copyright(c) Japan Contact Lens Association. All rights reserved<br>
        <a href="/law.html">特定商取引法に基づく表記</a></small></p>
    </div>
  </footer>
</template>

<style scoped lang="scss">
.commonFooter {
  margin-top: 80px;
  color: #fff !important;

  > div {
    background-color: #007bff !important;
    color: #FFF;

    > p {
      font-size: 16px;
      line-height: 24px;
      text-align: center !important;
      padding-bottom: 8px !important;
      padding-top: 8px !important;
      margin-bottom: 0 !important;
      margin-top: 0;
      margin-bottom: 8px;

      > small {
        font-size: 12.8px;
        text-align: 19.2px;
      }

      a {
        color: #FFF;
        text-decoration: underline;
      }
    }
  }
}
</style>
